if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', function () {
		initHlsScroll();
	});
} else {
	initHlsScroll();
}

function initHlsScroll() {
	const options = {
		rootMargin: '0px 0px -35% 0px'
	}

	const hlsObserver = new IntersectionObserver(function (entries, observer) {
		entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				if(entry.target.classList.contains('js-hls-autoplay')){
					entry.target.play();
				}
			} else {
				entry.target.pause();
			}
		}, {});
	}, options);

	document.querySelectorAll("[id^='hls-video-']").forEach(hlsVideo => {
		hlsObserver.observe(hlsVideo)
	});
}
